/**
 * @description
 * Behavior for a datepicked calendar component
 * @specification
 * Adds attribute 'aria-live=polite' to 'label' slot.
 */
export var datepickerCalendarHeaderBehavior = function datepickerCalendarHeaderBehavior() {
  return {
    attributes: {
      label: {
        'aria-live': 'polite'
      }
    }
  };
};
//# sourceMappingURL=datepickerCalendarHeaderBehavior.js.map
